import React, { Component } from "react";
import { render } from 'react-dom'

import { Dropdown, Icon, Input, Menu, Button, Image, Header, Segment, Grid, Divider, Label } from 'semantic-ui-react'
import { injectIntl, defineMessages, FormattedMessage, } from "react-intl";
import _ from "lodash"

import "./StoriesMenu.css";

import deepsingLogo from "./images/deepsing.png"
import deepsingLogoWhite from "./images/deepsing_white.png"

import deepsingLogoText from "./images/deepsing_text.png"
import PlayerContext from "../../../playerContext";
import Moto from "../Moto/Moto";
import YouTubePlayer from "../../YouTubePlayer/YouTubePlayer";
import Typewriter from 'typewriter-effect';
import Draggable from "react-draggable";
import StoryGraph from "./StoryGraph/StoryGraph";
import StoryLogo from "./StoryLogo/StoryLogo";
import Axios from "axios";

const messages = defineMessages({
})

class StoriesMenu extends Component {
    state = {
        story: null,
    }

    static contextType = PlayerContext

    componentDidUpdate = () => {
    }

    componentDidMount = () => {
        const playerStatus = this.context
        const storyId = playerStatus.storyId;

        Axios.get(`/engine/deepData/${storyId}.json`)
        .then(result => {playerStatus.setMetadata(result.data)})
        .catch(error => {console.log(error)});
    }

    timeToMetadata = (time) => {
        const playerStatus = this.context
        return _.head(_.filter(playerStatus.metadata, (instance) => {
            return time >= instance.time && time <= instance.time + 0.6
        }))
    }

    render() {
        const { location, story, type } = this.state

        const { intl: { formatMessage } } = this.props;

        const playerStatus = this.context

        const currentMeta = playerStatus.metadata ? this.timeToMetadata(playerStatus.currentSeconds) : null

        const currentSentiment  = currentMeta && currentMeta.stylizer_sentiment? currentMeta.stylizer_sentiment : ""

        return (
            <div
                className="draggableLogo"
                style={{
                    "zIndex": "9999",
                    "position": "absolute",
                    
                    "maxWidth" : "100vw",
                    
                    "maxHeight": "30vh"
                }}
            >
                
                <Draggable>
                
                    <Grid columns={2}  textAlign='center'>
                    
                        <Divider vertical></Divider>
                        
                        <Grid.Row verticalAlign='middle'>
                        
                            <Grid.Column>
                            <Label as='a' color='red' ribbon >
                                    Drag me
                                </Label>                
                                {/* <Image src={deepsingLogoWhite} className="deepsingLogo" alt="deepsing" centered /> */}
                                <StoryLogo/>
                                <Header style={{ "color": "white", "padding": "0px" }} >deepsing</Header>
                            </Grid.Column>

                            <Grid.Column style={{"paddingTop": "47px"}}>
                                {/* <Header icon>
            <Icon name='world' />
                     {currentMeta && currentMeta.sound_arousal}
                     {currentMeta && currentMeta.sound_valence}
                     {currentMeta && currentMeta.gan_class}
                     {currentMeta && currentMeta.stylizer_sentiment}
          </Header>
          <Button primary>Create</Button> */}
                                <StoryGraph />
                                <div style={{ "marginTop": "20px", "height": "50px", "width": "190px" }}>
                                    <span>{currentMeta && `Drawing a ${currentSentiment} ${currentMeta.gan_class}`}</span>
                                </div>

                            </Grid.Column>
                        </Grid.Row>
                    </Grid>

                </Draggable>


            </div>
            // <Menu vertical fluid style={{ "background": "black", "color": "white" }} >
            //    <Draggable>
            //     <Image src={deepsingLogoWhite} className="deepsingLogo" alt="deepsing" centered />
            //     </Draggable>
            //     {/* <Image src={deepsingLogoText} className="deepsingLogoText" alt="deepsing" centered /> */}
            //     <Header as='h1' textAlign='center' style={{ "paddingTop": "0px", "marginTop": "0px" }}>deepsing</Header>
            //     {/* <svg class="ui image centered" width="273" height="182" xmlns="http://www.w3.org/2000/svg">
            //         <g>
            //             <title>background</title>
            //             <rect height="184" width="275" fill="#fff" id="canvas_background" y="-1" x="-1" />
            //         </g>

            //         <g>
            //             <title>Layer 1</title>
            //             <g stroke="null" id="svg_28">
            //                 <g stroke="null" transform="matrix(0.47372352124447675,0,0,0.47372352124447675,-4544.585921735476,-1472.8828337804327) " id="svg_25" class="fa-group">
            //                     <path stroke="null" id="svg_26" d="m10165.8483,3286.56108c-54.23,-105.81 -161.59,-177.4 -284.52,-177.4s-230.32,71.64 -284.52,177.41a32.35,32.35 0 0 0 0,29.19c54.23,105.81 161.59,177.4 284.52,177.4s230.32,-71.64 284.52,-177.41a32.35,32.35 0 0 0 0,-29.19zm-284.38,158.6l-0.14,0a143.93,143.93 0 1 1 0.14,0z" fill="#fffffff" class="fa-secondary" />
            //                     <path stroke="null" id="svg_27" d="m9973.9883,3326.03108a95.78,95.78 0 1 1 -184.87,-50.18a47.85,47.85 0 0 0 66.9,-66.9a95.3,95.3 0 0 1 118,117.08l-0.03,0z" fill="#000000" class="fa-primary" />
            //                 </g>
            //             </g>
            //             <ellipse ry="63.5" rx="63.5" id="svg_29" cy="92.28809" cx="133.43201" stroke-opacity="null" stroke-width="null" stroke="null" fill="#ffffff" />
            //             <g stroke="null" id="svg_8">
            //                 <path stroke="null" id="svg_7" d="m202.6624,92.50704l-11.53939,0l-4.52801,-11.84777a4.43058,2.56225 0 0 0 -8.62627,-0.00897l-7.04015,17.96766l-7.31041,-30.04601a4.43058,2.56225 0 0 0 -8.78357,0.05764l-6.53506,32.0279l-9.47915,-40.27188a4.43058,2.56225 0 0 0 -8.77694,0l-9.48359,40.27445l-6.53505,-32.02789a4.43058,2.56225 0 0 0 -8.78577,-0.05638l-7.31041,30.04601l-7.03351,-17.97149a4.43058,2.56225 0 0 0 -8.62627,0.00641l-4.52801,11.85033l-11.53939,0a2.65831,1.53733 0 0 0 -2.65831,1.53733l0,2.04977a2.65831,1.53733 0 0 0 2.65831,1.53734l15.0639,0a4.40174,2.54557 0 0 0 4.31314,-1.98573l1.03233,-2.55453l8.0636,20.49783c0.49177,1.2414 2.16654,1.97806 4.48596,1.97806l0.04874,0a4.41726,2.55454 0 0 0 4.15363,-2.19839l5.87046,-24.25922l6.61258,32.40071a4.43058,2.56225 0 0 0 8.79022,0.04357l9.79594,-41.55556l9.78932,41.55556a4.43058,2.56225 0 0 0 8.79246,-0.04357l6.6104,-32.40071l5.87046,24.25538a4.43058,2.56225 0 0 0 4.18911,2.20223c2.19977,0.06789 4.00076,-0.72128 4.50586,-1.97806l8.06585,-20.49783l1.03009,2.55197a4.40398,2.54686 0 0 0 4.31314,1.9883l15.06389,0a2.65831,1.53733 0 0 0 2.65832,-1.53734l0,-2.04977a2.65831,1.53733 0 0 0 -2.65832,-1.53733l-0.00015,0l0.00002,-0.00002z" fill="currentColor" />
            //             </g>
            //         </g>
            //     </svg> */}
            //     <Menu.Item>
            //         {currentMeta && currentMeta.sound_arousal}
            //     </Menu.Item>
            //     <Menu.Item>
            //         {currentMeta && currentMeta.sound_valence}
            //     </Menu.Item>
            //     <Menu.Item>
            //         {currentMeta && currentMeta.gan_class}
            //     </Menu.Item>
            //     <Menu.Item>
            //         {currentMeta && currentMeta.stylizer_sentiment}
            //     </Menu.Item>

            //     <Menu.Item>

            //         {currentMeta && <Moto msg={currentMeta.gan_class} />}
            //     </Menu.Item>


            // </Menu>

        )
    }
}

export default injectIntl(StoriesMenu)